const SEP = "—";

export default function Marquee({ items, outline = true, className = "" }) {
  const row = [...items, ...items, ...items, ...items];
  return (
    <div data-testid="editorial-marquee" className={`overflow-hidden border-y border-wire py-5 ${className}`}>
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className={`font-display text-3xl sm:text-5xl font-extrabold uppercase tracking-tight ${outline ? "text-outline" : "text-neutral-200"}`}>
              {item}
            </span>
            <span className="font-mono text-neutral-600 text-xl">{SEP}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
